import React from "react";
import PropTypes from "prop-types";

import { DismissButton, SuccessButton } from "../..";
import sad from "../../assets/imgs/sad.svg";
import "./LiveError.scss";

const LiveError = ({ error, hasRetryButtons, onRetry, onQuit }) => {
  return (
    <div className="live-error">
      <img className="live-error__image" src={sad} alt="sad-smile" />
      <span className="live-error__text">
        {error}
      </span>
      {hasRetryButtons &&
        <div className="live-error__buttons">
          <DismissButton
            onClick={onQuit}
          >
            Quit
          </DismissButton>
          <SuccessButton
            onClick={onRetry}
          >
            Try Again
          </SuccessButton>     
        </div>
      }
    </div>
  );
};

LiveError.propTypes = {
  error: PropTypes.string, 
  hasRetryButtons: PropTypes.bool, 
  onQuit: PropTypes.func,
  onRetry: PropTypes.func 
};

LiveError.defaultProps = {
  error: "Somthing went wrong",
  hasRetryButtons: false,
  onQuit: () => {},
  onRetry: () => {}
}

export default LiveError;